export function imageUrl(imgName: string) {
  return `https://service.greatdealsdist.com/api/image/small/${imgName}?ext=jpg`;
}
